<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view />
  </div>
</template>

<script>
import db from '@/services/localstorage'
export default {
  name: 'app',
  data() {
    return {
      // 监听屏幕宽度
      screenWidth: document.body.clientWidth,
    }
  },
  methods: {},
  mounted() {
    const that = this
    window.onresize = function () {
      return (function () {
        that.screenWidth = document.body.clientWidth
      })()
    }
  },
  watch: {
    screenWidth(val) {
      // console.log(val)
      if (!this.timer) {
        this.timer = true
        let that = this
        setTimeout(function () {
          console.log(123123)
          location.reload()
          that.timer = false
        }, 1000)
      }
    },
    $route: {
      handler: function (newVal) {
        var o = {
          fullPath: newVal.fullPath,
          path: newVal.path,
        }
        db.save('LAST_URL', o)
      },
      // 深度观察监听
      deep: true,
    },
  },
}
</script>

<style lang="less">
.el-dialog__header {
  padding: 10px 5px 10px !important;
}
.el-divider--horizontal {
  height: 2px !important;
  margin: 14px 0 !important;
}

.messageBox {
  max-height: 80%;
  width: 30% !important;
  display: flex !important;
  margin: 5% auto !important;
  flex-direction: column;
  // justify-content: space-between;
  .el-message-box__content {
    // height: 80%;
    max-height: 80%;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0px; //滚动条的宽度
      height: 0px;
    }
  }
}

#nprogress .bar {
  background: #66b1ff !important; // 自定义颜色
  height: 2px !important; // 自定义高度
}

.el-cascader-menu{
  height: 400px;
}
</style>
